<template>
  <div class="cameralist">
    <router-view></router-view>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.cameralist {
  width: 100%;
  height: 100%;
  padding: 12px 16px;
}
</style>
